// shortcutManager.ts
type ShortcutAction = () => void;

const shortcuts = new Map<string, ShortcutAction>();

export function registerShortcut(key: string, action: ShortcutAction) {
  shortcuts.set(normalizeKey(key), action);
}

export function unregisterShortcut(key: string) {
  shortcuts.delete(normalizeKey(key));
}

export function handleKeydown(e: KeyboardEvent) {
  const pressedKey = buildPressedKey(e);
  const action = shortcuts.get(pressedKey);
  if (action) {
    e.preventDefault();
    action();
  }
}

function buildPressedKey(e: KeyboardEvent) {
  const keys = [];
  if (e.ctrlKey) keys.push("ctrl");
  if (e.metaKey) keys.push("meta");
  if (e.altKey) keys.push("alt");
  if (e.shiftKey) keys.push("shift");
  if (e.key === "+") keys.push("+");
  else if (e.key === "=") keys.push("=");
  else if (e.key === "-") keys.push("-");
  else keys.push(e.key.toLowerCase());
  return keys.join("+");
}

function normalizeKey(key: string) {
  return key.toLowerCase();
}

